import assignmentHelper from '../assignment/assignmentHelper';
import dataType from '../../../constants/dataType';
import NumberDeclarationHelper from '../../../types/Functions/NumberDeclarationHelper';
import ReportLogicLocation from '../../../../types/functions/Location/ReportLogicLocation';
import ReportVariable from '../../../../types/report/ReportVariable';
import Mode from '../../../../types/report/Mode';
import ReportConfig from '../../../../types/report/ReportConfig';

class VariableHelper extends NumberDeclarationHelper<ReportVariable> {

    getDeclarations(config: ReportConfig, location: ReportLogicLocation): ReportVariable[] {

        return config.variables;
    }

    getEmpty(rawDataSourceId: number | null): ReportVariable {

        let assignment = assignmentHelper.getEmpty(false);
        assignment.number = 1;

        return {
            id: null,
            name: '',
            number: 0,
            dataSourceId: rawDataSourceId,
            dataType: dataType.boolean,
            assignment: assignment,
            businessDescription: '',
            isSystem: false,
            errors: [],
            _internalId: 1,
            lastUpdatedTime: undefined,
            mode: Mode.Local,
            globalVariableModuleId: 0
        };
    }
}

const variableHelper = new VariableHelper();

export default variableHelper;
